module.exports = __webpack_public_path__ + "static/media/YF95_4.2211ca5f.jpg";